import { useEffect } from "react";
import { useDocument } from "@hooks/useDocument";
const useOutsideClick = ({ refs, callback }) => {
    const customDoc = useDocument();
    const handleClick = (event) => {
        if (refs.current.length === 0 || refs.current.some((ref) => ref === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
            return;
        }
        callback();
    };
    useEffect(() => {
        if (!customDoc) {
            return;
        }
        const sub = customDoc ? customDoc.addEventListener("click", handleClick) : null;
        return () => sub;
    });
};
export default useOutsideClick;
